import { DomainCrudService } from "../../apis/mgmt/DomainCrudService";
import { Domain } from "../../apis/mgmt/api";
import { EditableProps, useStatefulApiEditable } from "../common/Editable";
import { ListProps, } from "../common/List";
import { ToggleableProps, useStatefulToggleable } from "../common/Toggleable";
import { DomainEditable } from "./DomainEditable";
import { DomainFilteredList, useDomainFilteredPaginated as useDomainFilteredList } from "./DomainFilteredList";
import { DomainPageLayout } from "./DomainPageLayout";


export function useDomainPage(props: {
    listProps: ListProps<Domain>,
    toggle: ToggleableProps,
    editableProps: EditableProps<Domain>,
    defaultAddItemData?: Domain
}) {

    const { listProps, toggle, editableProps } = props;

    listProps.onAddItem = () => {
        editableProps.edit(props.defaultAddItemData);
        toggle.show();
    };

    listProps.onEditItem = (item: Domain) => {
        editableProps.edit(item);
        toggle.show();
    };

    editableProps.onSaved = (item: Domain, hideAfterSaving: boolean) => {
        listProps.setItem(item);
        if (hideAfterSaving) toggle.hide();
    };

    editableProps.onDeleted = (item: Domain) => {
        listProps.deleteItem(item);
        toggle.hide();
    };

    return props;
}


export const DomainPage = function () {
    
    const domainFilteredListProps = useDomainFilteredList()
    const { listProps } = domainFilteredListProps;

    const detailToggle = useStatefulToggleable(false);
    const editableProps = useStatefulApiEditable(DomainCrudService, undefined, undefined, detailToggle);

    useDomainPage({ listProps, editableProps, toggle: detailToggle });

    return (
        <DomainPageLayout
            list={<DomainFilteredList {...domainFilteredListProps} />}
            detailToggle={detailToggle}
            detailForm={<DomainEditable {...editableProps} />}
            onDetailCancel={editableProps.cancel}
        />
    );

};